import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import JellyRadio from "./JellyRadio";

const storageKey = "solufy-color-theme";
const SunIcon = () => <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41"/></svg>;
const MoonIcon = () => <svg viewBox="0 0 24 24"><path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z"/></svg>;

function JellyTheme() {
	const [theme, setTheme] = useState(document.documentElement.dataset.solufyTheme || "light");

	useEffect(() => {
		const sync = (event) => setTheme(event.detail);
		window.addEventListener("solufy-theme-change", sync);
		return () => window.removeEventListener("solufy-theme-change", sync);
	}, []);

	const changeTheme = (nextTheme) => {
		window.localStorage.setItem(storageKey, nextTheme);
		document.documentElement.dataset.solufyTheme = nextTheme;
		window.dispatchEvent(new CustomEvent("solufy-theme-change", { detail: nextTheme }));
	};

	return <JellyRadio items={[{ value: "light", label: "Light", icon: <SunIcon /> }, { value: "dark", label: "Dark", icon: <MoonIcon /> }]} value={theme} onChange={changeTheme} chipColor="#27272a" activeColor="#f5f5f5" textColor="#f5f5f5" activeTextColor="#18181b" size="md" gap={4} radius={18} swell={0.2} barge={6} shrink={0.05} jelly={1} bounce={0.25} stagger={22} stiffness={580} label="Color theme" />;
}

export function mountJellyTheme(root = document) {
	root.querySelectorAll("[data-jelly-theme]").forEach((container) => {
		if (container.dataset.mounted) return;
		container.dataset.mounted = "true";
		ReactDOM.createRoot(container).render(<JellyTheme />);
	});
}
